import React, { useEffect, useMemo, useRef, useState } from "react";
import { CSSTransition, TransitionGroup, } from 'react-transition-group';
import { useTranslation } from "react-i18next";
import moment from "moment";
import { cloneDeep } from 'lodash';
import { BsFillGrid1X2Fill } from "react-icons/bs";
import {
  clearAlert, clearCameraSerials,
  setCameraSerials,
  setFilteringAlerts,
  socketEmitEvent,
  toggleSmartMode
} from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown, Menu, Select } from "antd";
import { PiPhoneOutgoingFill } from "react-icons/pi";
import IconSize66On from "../../assets/icons/6-active.svg";
import IconSize66Off from "../../assets/icons/6-noactive.svg";
import IconSize65On from "../../assets/icons/5-active.svg";
import IconSize65Off from "../../assets/icons/5-noactive.svg";
import IconSize16On from "../../assets/icons/size_16_on.svg";
import IconSize16Off from "../../assets/icons/size_16_off.svg";
import IconSize9On from "../../assets/icons/size_9_on.svg";
import IconSize9Off from "../../assets/icons/size_9_off.svg";
import IconSize4On from "../../assets/icons/size_4_on.svg";
import IconSize4Off from "../../assets/icons/size_4_off.svg";
import FaceDetection from "../../assets/icons/face_detection.png";
import FireDetection from "../../assets/icons/fire_detection.png";
import ObjectDetection from "../../assets/icons/object_detection.png";
import PersonDetection from "../../assets/icons/person_detection.png";
import WallDetection from "../../assets/icons/wall_detection.png";
import WeaponDetection from "../../assets/icons/weapon_detection.png";
import * as SERVICE from "../../constants/service.types";
import { PHONE_REGISTER_STATUS, PHONE_STATES } from "../../constants/system.keys";
import { Inviter, Registerer, SessionState, UserAgent } from "sip.js";
import PersonnelInChargePopup from "./PersonnelInChargePopup";
import InCallingPopup from "./InCallingPopup";
import { MdEmail } from "react-icons/md";
import SendEmailPopup from "./SendEmailPopup";
import { IoCloseCircleSharp, IoMic } from "react-icons/io5";
import { uniqRequestId } from "../../untils/unique";
import { EDEVICETYPE } from "../../constants";
import ViewCameraPopup from "./ViewCameraPopup";
import { FaPlay } from "react-icons/fa";
import { nextRequestId } from "../../socket/query"

const DEFAULT_SIP_PORT = 7443;
export const CALL_TYPE = {
  PHONE: 1,
  SPEAKER: 2
}

const AlertBox = ({events = [], pagination, onSelect, setPagination, gateways = [], data}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [selectedAlert, setSelectedAlert] = useState(null);
  const [registerStatus, setRegisterStatus] = useState(
    PHONE_REGISTER_STATUS.UNSET
  );
  const [userAgent, setUserAgent] = useState(null);
  const [register, setRegister] = useState(null);
  const [phoneState, setPhoneState] = useState(PHONE_STATES.NOT_SET);
  const [isCalling, setIsCalling] = useState(false);
  const [outCallSession, setOutCallSession] = useState(null);
  const [isValidConfig, setIsValidConfig] = useState(false);
  const [personnelInChargePopupVisible, setPersonnelInChargePopupVisible] = useState(false);
  const [callingPopupVisible, setCallingPopupVisible] = useState(false);
  const [sendEmailPopupVisible, setSendEmailPopupVisible] = useState(false);
  const [modalViewCamera, setModalViewCamera] = useState(false);
  const [camera, setCamera] = useState(null);
  const callingPhoneNumber = useRef(null);
  const [callType, setCallType] = useState(CALL_TYPE.PHONE);

  const MAX_ALERT = 100;

  const { namespace, listDeviceContact, sipAccount, listSpeakerSip, listDeviceGroupByPage } = useSelector((state) => state);

  const [deviceContact, setDeviceContact] = useState(null);

  const remoteStream = new MediaStream();
  const audioRef = useRef();

  const sessionEvents = useMemo(() => {
    const clonedEvents = cloneDeep(events);
    return clonedEvents.slice(0, MAX_ALERT);
  }, [events]);

  console.log("SESSION EVENTS", sessionEvents)

  const alertIcon = useMemo(() => ({
    [SERVICE.DETECT_OBJECT]: ObjectDetection,
    [SERVICE.DETECT_PERSON]: PersonDetection,
    [SERVICE.DETECT_WEAPON]: WeaponDetection,
    [SERVICE.DETECT_FIRE]: FireDetection,
    [SERVICE.DETECT_VIRTUAL_WALL]: WallDetection,
    [SERVICE.RECOGNITION_FACE]: FaceDetection,
  }), [])

  const contactRequestId = useRef(0);

  const getContactInfo = (serial) => {
    if (serial && namespace) {
      contactRequestId.current = nextRequestId()

      let dataBody = {
        namespace,
        serial,
      };
      let dataObj = {
        appServiceType: SERVICE.GET_DEVICE_CONTACT_INFO,
        requestId: contactRequestId.current,
        body: JSON.stringify(dataBody),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }

  useEffect(() => {
    if (listDeviceContact && listDeviceContact.requestId === contactRequestId.current) {
      setDeviceContact(listDeviceContact);
    }
  }, [listDeviceContact]);

  const setupRemoteMedia = (session) => {
    session.sessionDescriptionHandler.peerConnection
      .getReceivers()
      .forEach((receiver) => {
        if (receiver.track) {
          remoteStream.addTrack(receiver.track);
        }
      });

    if (audioRef.current) {
      audioRef.current.srcObject = remoteStream;
      audioRef.current.play();
    }
  };

  const cleanupMedia = () => {
    if (audioRef.current) {
      audioRef.current.srcObject = null;
      audioRef.current.pause();
    }
  };

  const registerSipCall = () => {
    if (sipAccount && isValidConfig) {
      setRegisterStatus(PHONE_REGISTER_STATUS.REGISTERING);

      const uaConfig = {
        displayName: sipAccount.username,
        uri: UserAgent.makeURI(
          `sip:${sipAccount.username}@${sipAccount.endpoint}:${
            sipAccount.port || DEFAULT_SIP_PORT
          }`
        ),

        transportOptions: {
          server: `wss://${sipAccount.endpoint}:${
            sipAccount.port || DEFAULT_SIP_PORT
          }`,
          connectionTimeout: 100,
          keepAliveInterval: 20,
        },
        authorizationPassword: sipAccount.password,
        authorizationUsername: sipAccount.username,
        delegate: {
          onConnect: () => {
            console.log('====> onConnect');
            setRegisterStatus(PHONE_REGISTER_STATUS.REGISTERING);
          },
          onRegister: (r) => {
            console.log('====> onRegister');
          },
          onDisconnect: () => {
            console.log('====> onDisconnect');
          },
          onInvite: (invitation) => {
            console.log('====> Incoming call');
          },
        },
      };

      const ua = new UserAgent(uaConfig);
      const registerer = new Registerer(ua);

      // Add listen state change
      ua.transport.onConnect = () => {
        console.log('====> User Agent onConnect');
      };

      ua.transport.onDisconnect = () => {
        console.log('====> User Agent onDisconnect');
      };

      ua.start().then(() => {
        registerer.register({
          requestDelegate: {
            onAccept: (resp) => {
              console.log('Register is accepted: ', resp.message);
              setRegisterStatus(PHONE_REGISTER_STATUS.READY);
            },
            onReject: (response) => {
              console.log(' Register is rejected ===> ', response.message);
              setRegisterStatus(PHONE_REGISTER_STATUS.UNSET);
            },
          },
        });
      });

      setUserAgent(ua);
      setRegister(registerer);
    }
  };

  const callBtnPressed = (phoneNumber) => {
    if (!userAgent) {
      registerSipCall();
    }

    setIsCalling(true);
    setPhoneState(PHONE_STATES.RINGING);

    const target = UserAgent.makeURI(
      `sip:${phoneNumber}@${sipAccount.endpoint}:${DEFAULT_SIP_PORT}`
    );
    if (!target) {
      console.error('Failed to create target URI.');
      return;
    }

    const inviter = new Inviter(userAgent, target, {
      sessionDescriptionHandlerOptions: {
        constraints: {
          audio: true,
          video: false,
        },
      },
    });

    inviter.stateChange.addListener((newState) => {
      switch (newState) {
        case SessionState.Establishing:
          console.log('==> Ringing call');
          setPhoneState(PHONE_STATES.RINGING);
          break;
        case SessionState.Established:
          console.log('===> Call Established');
          setPhoneState(PHONE_STATES.IN_CALL);
          setIsCalling(false);
          setupRemoteMedia(inviter);
          break;

        case SessionState.Terminated:
          console.log('===> Call Terminated');
          setPhoneState(PHONE_STATES.TERMINATED);
          setIsCalling(false);
          cleanupMedia();
          break;
        default:
          setPhoneState(PHONE_STATES.NOT_SET);
          break;
      }
    });

    inviter
      .invite()
      .then((res) => {
        setPhoneState(PHONE_STATES.CALLING_OUT);
        setIsCalling(true);
        console.log(`Calling out: ${inviter.remoteIdentity.uri.user}`);
      })
      .catch((err) => {
        console.log('Call has rejected: ', err);
        setPhoneState(PHONE_STATES.REJECTED);
        setIsCalling(false);
      });

    setOutCallSession(inviter);
  };

  const terminatedCall = () => {
    if (outCallSession) {
      if (outCallSession.state === SessionState.Established) {
        outCallSession.bye();
      } else {
        outCallSession.cancel();
      }
    }
  };

  useEffect(() => {
    if (!sipAccount) {
      setIsValidConfig(false);
    } else {
      if (
        !sipAccount?.endpoint ||
        !sipAccount?.username ||
        !sipAccount?.password
      ) {
        setIsValidConfig(false);
      } else {
        setIsValidConfig(true);
      }
    }
  }, [sipAccount]);

  useEffect(() => {
    registerSipCall();
  }, [sipAccount, isValidConfig]);

  useEffect(() => {
    if (namespace) {
      let dataBody = {
        namespace,
        timeRequest: uniqRequestId(19, EDEVICETYPE.SPEAKER),
        deviceType: EDEVICETYPE.SPEAKER,
        page: 0,
        size: -1,
      };

      let dataObj = {
        appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };

      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, namespace]);

  useEffect(() => {
    if (deviceContact) {
      const camera = data.find(item => item.serial === deviceContact.serial);
      setCamera(camera);
    }
  }, [deviceContact, data]);

  const menu = (
    <Menu>
      <Menu.Item key="0" onClick={() => setPagination({...pagination, size: 4, grid: [2, 2]})}>
        <img
          width={20}
          src={pagination.size === 4 ? IconSize4On : IconSize4Off}
          alt="mode"
        />
      </Menu.Item>
      <Menu.Item key="1" onClick={() => setPagination({...pagination, size: 9, grid: [3, 3]})}>
        <img
          width={20}
          src={pagination.size === 9 ? IconSize9On : IconSize9Off}
          alt="mode"
        />
      </Menu.Item>
      <Menu.Item key="2" onClick={() => setPagination({...pagination, size: 16, grid: [4, 4]})}>
        <img
          width={20}
          src={pagination.size === 16 ? IconSize16On : IconSize16Off}
          alt="mode"
        />
      </Menu.Item>
      <Menu.Item key="3" onClick={() => setPagination({...pagination, size: 30, grid: [5, 6]})}>
        <img
          width={20}
          src={pagination.size === 30 ? IconSize65On : IconSize65Off}
          alt="mode"
        />
      </Menu.Item>
      <Menu.Item key="4" onClick={() => setPagination({...pagination, size: 36, grid: [6, 6]})}>
        <img
          width={20}
          src={pagination.size === 36 ? IconSize66On : IconSize66Off}
          alt="mode"
        />
      </Menu.Item>
    </Menu>
  );

  useEffect(() => {
    const PAGE_INDEX = 0;
    const PAGE_SIZE = 9999;
    (() => {
      dispatch(
        socketEmitEvent({
          appServiceType: SERVICE.LIST_DEVICE_GROUP_BY_PAGE_V2,
          requestId: new Date().getTime(),
          body: JSON.stringify({
            namespace,
            page: PAGE_INDEX,
            size: PAGE_SIZE,
            timeRequest: new Date().getTime(),
          }),
        })
      )
    })();
  }, []);

  const onChange = (values) => {
    dispatch(clearCameraSerials([]));
    if (!values?.length) {
      dispatch(setFilteringAlerts(false));
    } else {
      dispatch(setFilteringAlerts(true));
      for (let i = 0; i < values.length; i++) {
        dispatch(
          socketEmitEvent({
            appServiceType: SERVICE.GET_DEVICE_GROUP_BY_ID,
            body: JSON.stringify({
              namespace,
              deviceGroupId: values[i],
            }),
          })
        );
      }
    }
  };

  const groupOptions = useMemo(() => {
    return listDeviceGroupByPage?.deviceGroups?.map(item => ({ label: item.name, value: item.id }));
  }, [listDeviceGroupByPage])

  return (
    <div
      className="alert-box"
      style={{width: `${pagination.size === 36 ? 360 : 332}px` }}
    >
      <ViewCameraPopup
        visible={modalViewCamera}
        gateways={gateways}
        onCancel={() => setModalViewCamera(false)}
        camera={camera}
        hideFullscreen
      />

      <PersonnelInChargePopup
        type={callType}
        visible={personnelInChargePopupVisible}
        assigners={deviceContact?.assigners}
        listSpeakerSip={listSpeakerSip}
        deviceLinks={deviceContact?.deviceLinks}
        onCancel={() => setPersonnelInChargePopupVisible(false)}
        onOK={(phoneNumber) => {
          callBtnPressed(phoneNumber);
          callingPhoneNumber.current = phoneNumber;
          setCallingPopupVisible(true);
        }}
      />

      <InCallingPopup
        visible={callingPopupVisible}
        onCancel={() => {
          terminatedCall();
          setCallingPopupVisible(false);
        }}
        phoneNumber={callingPhoneNumber.current}
        status={phoneState}
      />

      <SendEmailPopup
        onCancel={() => setSendEmailPopupVisible(false)}
        visible={sendEmailPopupVisible}
        emails={deviceContact?.assigners}
      />
      <div className="alert-box-header">
        <div>{t('AI View')}</div>
        <div>
          <div id="grid-dropdown">
            <Dropdown
              overlay={menu}
              getPopupContainer={() => document.getElementById("grid-dropdown")}
            >
              <BsFillGrid1X2Fill size={17} />
            </Dropdown>
          </div>
          <IoCloseCircleSharp onClick={() => {
            dispatch(toggleSmartMode(false));
            dispatch(clearAlert([]));
          }} />
        </div>
      </div>
      <div style={{ marginBottom: '16px' }}>
        <Select
          placeholder={'Select groups'}
          style={{ width: '100%' }}
          mode={'multiple'}
          showSearch
          onChange={(value, option) => onChange(value)}
          getPopupContainer={(trigger) => trigger.parentNode}
          showArrow={false}
          filterOption={(inputValue, option) => option.label.toLowerCase().includes((inputValue || '').toLowerCase().trim())}
          options={groupOptions || []}
        />
      </div>
      <div className="events">
        <TransitionGroup>
          {
            !!(sessionEvents && sessionEvents.length) && sessionEvents.map((event, index) => {
              const { cameraLocation, objects, actionTime, imageUrl, serial, serviceId } = event;

              return (
                <CSSTransition
                  key={event.clientId}
                  timeout={500}
                  classNames="transition-item"
                >
                  <div
                    className={`event-container ${event.clientId === selectedAlert ? 'selected' : ''}`}
                    onClick={() => {
                      const alertId = event.clientId;
                      setSelectedAlert(alertId);
                      onSelect(event);
                    }}
                  >
                    <div className="event-body">
                      <div className="event-col-left">
                        <div className="event-name">{objects || ''}</div>
                        <div
                          className="event-time">{actionTime ? moment(actionTime).format("YYYY-MM-DD HH:mm") : ''}</div>
                        <div className="event-action">
                        <div>
                            <PiPhoneOutgoingFill
                              size={16}
                              onClick={() => {
                                setCallType(CALL_TYPE.PHONE);
                                getContactInfo(serial);
                                setPersonnelInChargePopupVisible(true);
                              }}
                            />
                            <IoMic
                              size={16}
                              onClick={() => {
                                setCallType(CALL_TYPE.SPEAKER);
                                getContactInfo(serial);
                                setPersonnelInChargePopupVisible(true);
                              }}
                            />
                            <MdEmail
                              size={16}
                              onClick={() => {
                                getContactInfo(serial);
                                setSendEmailPopupVisible(true);
                              }}
                            />
                        </div>
                          <div className="col-right">
                            {/*<Checkbox>{t('Resolved')}</Checkbox>*/}
                          </div>
                        </div>
                      </div>
                      <div className="event-col-right">
                        <img width={40} src={imageUrl} alt=""/>
                        <FaPlay onClick={() => {
                          getContactInfo(serial);
                          setModalViewCamera(true);
                        }} />
                      </div>
                    </div>
                  </div>
                </CSSTransition>
              )
            })
          }
        </TransitionGroup>
      </div>
      {/*<div className="event-input">*/}
      {/*  <div className="control">*/}
      {/*    <Input />*/}
      {/*  </div>*/}
      {/*  <div className="action">*/}
      {/*    <AiOutlineSend size="22px" />*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  )
}

export default AlertBox;